import styled from 'styled-components';

export const CtaBanner = styled.section`
  background: ${({ theme }) =>
    `linear-gradient(135deg, ${theme.colors.accent} 0%, ${theme.colors.accentDark} 100%)`};
  padding: ${({ theme }) => `5.6rem ${theme.spacing.lg}`};
  text-align: center;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: ${({ theme }) => `4rem ${theme.spacing.lg}`};
  }

  &::before {
    content: '';
    position: absolute;
    top: -10rem;
    left: -5rem;
    width: 40rem;
    height: 40rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -10rem;
    right: -5rem;
    width: 30rem;
    height: 30rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }
`;

export const CtaHeading = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const CtaSub = styled.p`
  font-size: 1.6rem;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  line-height: 1.5;
`;

export const CtaButton = styled.a`
  display: inline-block;
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1.2rem;
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.xxl}`};
  cursor: pointer;
  text-decoration: none;
`;

export const CtaStats = styled.div`
  position: relative;
  margin: ${({ theme }) => theme.spacing.xl} 0;
`;
